<!--
  @author:chen.hao
  @time:2018/10/15
  @disc:供应商管理审核弹出层
 -->

<template>
  <el-dialog
    title="审核"
    :visible.sync="visible"
    width="800px"
    @close="handleClose">
    <el-form ref="form" :model="form" label-width="140px" :rules="rules">
      <info :info-data="info"></info>
      <el-form-item label="审批结果" prop="result">
        <el-radio-group v-model="form.result">
          <el-radio v-for="item in resultArr" :label="item.value" :key="item.value">{{item.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="审批备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入审批备注" class="input-remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import Info from './info'
export default {
  name: 'reviewDialog',
  components: { Info },
  props: ['show', 'info'],
  data () {
    return {
      visible: this.show,
      form: {},
      resultArr: [
        { value: 2, label: '通过' },
        { value: 1, label: '未通过' }
      ],
      rules: {
        result: [{ required: true, message: '请选择审批结果' }],
        remark: [{ required: true, message: '请先完善审批备注' }]
      }
    }
  },
  methods: {
    ...mapActions(['reviewSupplier', 'getSupplierList']),
    submit () {
      this.$refs.form.validate(val => {
        if (val) {
          const params = { ...this.form, id: this.info.id }
          this.reviewSupplier(params)
            .then(res => {
              return this.getSupplierList()
            })
            .then(() => {
              this.visible = false
            })
        }
      })
    },
    handleClose () {
      this.$emit('update:show', false)
      this.$refs.form.resetFields()
    }
  },
  watch: {
    show () {
      this.visible = this.show
    }
  }
}
</script>

<style lang="scss" scoped>
.input-remark {
  width: 200px;
}
</style>
